<script setup lang="ts">
import { ref } from "vue";
import type { SplitterProps } from "./splitter.types";
import { useSplitterGroup } from "composables/useSplitter";

const props = withDefaults(defineProps<SplitterProps>(), {
  direction: "horizontal",
  keyboardStep: 10,
});

const containerRef = ref<HTMLElement | null>(null);
const { classes } = useSplitterGroup({ props, containerRef });
</script>

<template>
  <div ref="containerRef" part="base" :class="classes" class="e-splitter" role="group">
    <slot />
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
